module.exports = __webpack_public_path__ + "img/cb_logo_blue 2.b7e74392.svg";